<template>
<div class="max-w-xl w-full h-64 rounded-xl overflow-hidden shadow-2xl bg-white flex flex-col justify-center">
    <div class="px-8 py-6 w-full text-center">
      <div class="font-bold text-2xl mb-4 text-gray-800">Custtomer AVG Spend</div>
      <p class="text-gray-900 text-3xl font-semibold tracking-wide">
        $1000
      </p>
    </div>
  </div>
</template>
<script>
import api from '../../../utils/axios';
import { ref } from 'vue';
    export default {
        name: 'AvgSpendTotalCard', //「AVG SPEND」（平均消費額）是指每個客戶每次交易、每天或特定期間內的平均花費。
        data() {
            return {
                sales: ref(),
            }
        },
        methods: {
           async getOrderSalesData() {
                const response = await api.get('/report/eachcustomeravgreport');
                console.log('OrderCard: 25');
                console.log(response.data[0].AVG_SALES)
                this.sales = response.data[0].AVG_SALES;
                //this.sales = response.data;
            }
        },
        mounted() {
        console.log('組件已掛載，開始獲取資料...');
        this.getOrderSalesData(); // 自動執行
    }
    }
</script>